export const textLowerCaseRegex = /^(?=.*[a-z])/;
export const textUpperCaseRegex = /^(?=.*[A-Z])/;
export const digitRegex = /^(?=.*[0-9])/;
export const spaceRegex = /^\S*$/;
export const specialCharRegex = /^(?=.*[`~!@#$%^&*()_+=-])/;
export const charLimitRegex = /^.{8,20}$/;
export const onlyCharsAndNumbers = /^[a-zA-Z0-9\s]*$/;
export const charLimitBetweenFourAndTwenty = /^.{4,20}$/;